/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPortfolioQueryResult } from '../../models/get-portfolio-query-result';

export interface ApiPortfolioGetPortfolioGet$Params {
  Id: string;
}

export function apiPortfolioGetPortfolioGet(http: HttpClient, rootUrl: string, params: ApiPortfolioGetPortfolioGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfolioQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioGetPortfolioGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPortfolioQueryResult>;
    })
  );
}

apiPortfolioGetPortfolioGet.PATH = '/api/Portfolio/GetPortfolio';
